module.exports = __webpack_public_path__ + "images/landing-page-c33c471b176bfb1f71c31987f9064a85.svg";